
import axiosInstance from "./axiosInstance";

const login = (loginData) => {
  loginData.username = loginData.username.toLowerCase();
  return axiosInstance.post(`/users/login`, loginData, {
    withCredentials: true,
    timeout: 5000,
  });
};

export default login;
